import { automatableTypes } from '../../configuration/artifacts';
import { getInvoiceCodeRequests } from '../artifacts';
import { getArtifactSet } from '../case/artifact-sets';
import {
  artifactsForDisplay,
  filterAndAssembleArtifactList,
  isLinkable,
  sortInvoices
} from './artifact-filters';
import { codeEditFilter } from './code-edit-filter';
import { EvidenceManager } from './evidence-manager';
import {
  buildEvidenceFeatures,
  getDescription,
  getFeature,
  getFeatureForSelection,
  hasSentence,
  isBlockHighlight,
  isDisplayedFeature,
  isMultipleSelection,
  isSingleSelection,
  isSubhighlight,
  linkableEvidenceTypes
} from './feature-utils';
import { getArtifactDescripton, getCode } from './lookup';
import { preprocessor } from './preprocessor';
import {
  artifactToSimplifiedInvoice,
  handleImportedCases
} from './artifact-to-invoice';

import * as artifactSets from './artifact-sets';

export const cmxArtifacts = {
  sortInvoices,
  getArtifactSet,
  getInvoiceCodeRequests,
  artifactsForDisplay,
  artifactSets,
  EvidenceManager,
  filterAndAssembleArtifactList,
  codeEditFilter,
  isDisplayedFeature,
  linkableEvidenceTypes,
  isSubhighlight,
  isBlockHighlight,
  getDescription,
  hasSentence,
  isSingleSelection,
  isMultipleSelection,
  getFeature,
  getFeatureForSelection,
  buildEvidenceFeatures,
  getCode,
  getArtifactDescripton,
  preprocessor,
  automatableTypes,
  handleImportedCases,
  artifactToSimplifiedInvoice,
  isLinkable
};
